export const querySearchContent = (request, { signal, ...data }) =>
  request({
    method: 'post',
    pathname: '/api/search/query',
    data,
    signal,
  });

export const highlightSearchContent = (request, { signal, ...data }) =>
  request({
    method: 'post',
    pathname: '/api/search/highlight-content',
    data,
    signal,
    notShowErrorMessage: true,
  });
